import VueSweetalert2 from "vue-sweetalert2"
import "sweetalert2/dist/sweetalert2.min.css"
import { Alert } from "~/logic/alert.logic"

export default {
    install(app) {
        const options = {
            confirmButtonColor: "#34eb84",
            cancelButtonColor: "#b71c1c",
        }

        app.use(VueSweetalert2, options)
        Alert.setApp(app)
        app.config.globalProperties.$alert = Alert

        const style = document.createElement("style")
        style.innerHTML = ".swal2-container { z-index: 9999999999 }"
        document.head.appendChild(style)
    },
}
